module.exports = __webpack_public_path__ + "static/ortadogu1-73e3933b4c7df2719b6ae7855c01a1bb.png";